import React from 'react'
import Introduction from './components/Introduction'

function App() {
  return (
    <Introduction/>
  )
}

export default App
